<template>
  <div class="report-select-ratio">
    <a-radio-group v-model="paramObj.reportType" @change="changeRadio">
      <a-radio :value="1">实时数据</a-radio>
      <a-radio :value="2">日报</a-radio>
      <a-radio :value="3">月报</a-radio>
    </a-radio-group>
    <a-date-picker v-model="paramObj.date" v-if="paramObj.reportType==2" style="margin-left: 10px;" />
    <a-month-picker v-model="paramObj.date" v-if="paramObj.reportType==3" style="margin-left: 10px;" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      paramObj:{
        reportType:2,
        date:''
      }
    };
  },
  watch:{
    paramObj:{
      handler(newVal,oldVal){
        console.log('paramObj.reportType',newVal)
      },
      immediate:true,
      deep:true
    }
  },
  methods: {
    changeRadio(e) {
      console.log('changeRadio', e)

    }
  }
}
</script>

<style lang="scss" scoped>
  .report-select-ratio{
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
  }
</style>
